/**
 * One derivation source rendered the way MARC is written: `400$c`, or
 * `110$g [GENERAL_QUALIFIER]` when the value is read out of a parsed component
 * rather than the whole subfield.
 *
 * Shared by the rules list (the "Pole" column and its text filter) and the rule
 * detail's pane subtitle, so a rule reads the same in both places (CZNA-565).
 */
export var formatDerivationSource = function (source) { return ("".concat(source.fieldTag, "$").concat(source.subfieldCode).concat(source.componentType ? " [".concat(source.componentType, "]") : '')); };
/** Every source of a rule, comma-separated, in the rule's declared order. */
export var formatDerivationSources = function (sources) { return sources.map(formatDerivationSource).join(', '); };
